// import { convertFileToBase64 } from "../utils/convertToBase64";

export const generateCorporateFormData = async (formData, isSubmitted) => {
  console.log("FormData2: ", formData?.corporateDocumentUpload);
  // Helper function to process file uploads
  // const convertFile = async (file) => {
  //   if (!file) return { extension: "", data: "" };
  //   const base64 = await convertFileToBase64(file);
  //   const extension = file.extension
  //     ? `.${file.extension.split(".").pop()}`
  //     : "";
  //   return { extension, data: base64 || "" };
  // };

  const co7CacFormfilebase64 =
    formData?.corporateDocumentUpload?.co7CacForm?.data;
  const co7CacFormfileExtension =
    formData?.corporateDocumentUpload?.co7CacForm?.extension;
  const directorPassport1filebase64 =
    formData?.corporateDocumentUpload?.directorPassport1?.data;
  const directorPassport1fileExtension =
    formData?.corporateDocumentUpload?.directorPassport1?.extension;
  const companyProfilefilebase64 =
    formData?.corporateDocumentUpload?.companyProfile?.data;
  const companyProfilefileExtension =
    formData?.corporateDocumentUpload?.companyProfile?.extension;
  const directorPassport2filebase64 =
    formData?.corporateDocumentUpload?.directorPassport2?.data;
  const directorPassport2fileExtension =
    formData?.corporateDocumentUpload?.directorPassport2?.extension;
  return {
    corporateInfo: {
      nameOfOrganzation: formData?.corporateInfo?.nameOfOrganzation || "",
      address: formData?.corporateInfo?.address || "",
      state: formData?.corporateInfo?.state || "",
      city: formData?.corporateInfo?.city || "",
      postalAddress: formData?.corporateInfo?.postalAddress || "",
      phoneNumber: formData?.corporateInfo?.phoneNumber || "",
      emailAddress: formData?.corporateInfo?.emailAddress || "",
      typeOfBussiness: formData?.corporateInfo?.typeOfBusiness || "",
      productOrService: formData?.corporateInfo?.productOrService || "",
      noOfEmployees: formData?.corporateInfo?.noOfEmployees || 0,
      faxNo: formData?.corporateInfo?.faxNo || 0,
      yearOfIncorporation: formData?.corporateInfo?.yearOfIncorporation || "",
      rcNo: formData?.corporateInfo?.rcNo || 0,
      liability: formData?.corporateInfo?.liability || "",
      itInterestArea: formData?.corporateInfo?.itInterestArea || 0,
      interestGroups: formData?.corporateInfo?.interestGroups || 0,
    },

    principalDirectors:
      formData?.principalDirectors?.map((director) => ({
        title: director?.title || "",
        surname: director?.surname || "",
        firstName: director?.firstName || "",
        phoneNumber: director?.phoneNumber || "",
        address: director?.address || "",
        specialITInterest: director?.specialITInterest || "",
      })) || [],
    corporateDocumentUpload: {
      co7CacForm: co7CacFormfilebase64
        ? {
            extension: `.${co7CacFormfileExtension}`,
            data: co7CacFormfilebase64,
          }
        : null,
      companyProfile: companyProfilefilebase64
        ? {
            extension: `.${companyProfilefileExtension}`,
            data: companyProfilefilebase64,
          }
        : null,
      directorPassport1: directorPassport1filebase64
        ? {
            extension: `.${directorPassport1fileExtension}`,
            data: directorPassport1filebase64,
          }
        : null,
      directorPassport2: directorPassport2filebase64
        ? {
            extension: `.${directorPassport2fileExtension}`,
            data: directorPassport2filebase64,
          }
        : null,
    },
    refereeInfo: {
      membershipId: formData?.refereeInfo?.membershipId || "",
      fullName: formData?.refereeInfo?.fullName || "",
      email: formData?.refereeInfo?.email || "",
      phoneNumber: formData?.refereeInfo?.phoneNumber || "",
      qualification: formData?.refereeInfo?.qualification || "",
      jobTitle: formData?.refereeInfo?.jobTitle || "",
    },
    isSubmitted,
  };
};
